import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "row no-gutters pt-4 border-bottom" };
const _hoisted_2 = {
    class: "col-lg-6",
    style: {}
};
const _hoisted_3 = {
    class: "row no-gutters",
    style: { "display": "flex", "align-items": "center" }
};
const _hoisted_4 = { class: "h3-responsive d-inline-block mr-3" };
const _hoisted_5 = {
    key: 0,
    class: "pill d-inline-block font8-responsive bg-brand_red fc-white percentPill"
};
const _hoisted_6 = { class: "row no-gutters mb-3" };
const _hoisted_7 = {
    key: 0,
    class: "font5-responsive text-nowrap font-weight-normal",
    style: { "text-decoration": "line-through" }
};
const _hoisted_8 = { class: "row no-gutters font8-responsive" };
const _hoisted_9 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_10 = {
    key: 0,
    class: "col-lg-6 order-lg-1 order-2 pl-lg-3 pb-4"
};
const _hoisted_11 = { class: "col-12 order-lg-2 order-1 pt-4 pb-4 d-flex align-items-start" };
const _hoisted_12 = { class: "mb-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const _component_tax_hint = _resolveComponent("tax-hint");
    const _component_blue_add_cart = _resolveComponent("blue-add-cart");
    const _component_blue_shipping_period_info = _resolveComponent("blue-shipping-period-info");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.currentPriceCommaSeperated), 1),
                ((_a = _ctx.currentProduct) === null || _a === void 0 ? void 0 : _a.dealPrice)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, " - " + _toDisplayString((_b = _ctx.currentProduct) === null || _b === void 0 ? void 0 : _b.percent) + " % ", 1))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
                ((_c = _ctx.currentProduct) === null || _c === void 0 ? void 0 : _c.dealPrice)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString((_d = _ctx.currentProduct) === null || _d === void 0 ? void 0 : _d.originalPrice) + " € ", 1))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
                (((_e = _ctx.currentProduct) === null || _e === void 0 ? void 0 : _e.currentPrice) > 100)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createTextVNode(" Ab " + _toDisplayString(_ctx.karnaRateCommaSeperated) + " / Monat. In " + _toDisplayString((_f = _ctx.currentProduct) === null || _f === void 0 ? void 0 : _f.countKlarnaRates) + " Raten mit ", 1),
                        _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Klarna", -1)),
                        _cache[3] || (_cache[3] = _createTextVNode(" . ", -1)),
                        _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.klarnaPopUp && _ctx.klarnaPopUp(...args)), ["prevent"])),
                            href: "/kaufen",
                            title: "Klarna Infos",
                            class: "d-inline-block link-in-text"
                        }, " Details ")
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_tax_hint, {
                    tax: (_g = _ctx.currentProduct) === null || _g === void 0 ? void 0 : _g.taxRate
                }, null, 8, ["tax"])
            ])
        ]),
        ((_h = _ctx.currentProduct) === null || _h === void 0 ? void 0 : _h.stockAvailable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_blue_add_cart, { class: "[ CY_AddToCartButton ]" }),
                _createElementVNode("button", {
                    class: "buttonBase buttonBlueInverted w-100 mt-3 [ CY_PaypalExpressButton ]",
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.dispatchPaypalExpress && _ctx.dispatchPaypalExpress(...args)))
                }, " Mit PayPal Express bezahlen ")
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
            _cache[4] || (_cache[4] = _createElementVNode("img", {
                src: "/images/_new_brand/icons_in_brand_design/icon_time.png",
                class: "mr-2",
                alt: "Check",
                width: "32",
                height: "25"
            }, null, -1)),
            _createElementVNode("p", _hoisted_12, [
                _createVNode(_component_blue_shipping_period_info)
            ])
        ])
    ]));
}
